'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const router = useRouter();
  const [usr, setUsr] = useState('');
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usr, pwd }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Credenciales inválidas');
      router.push(data.redirect || '/app');
      router.refresh();
    } catch (err) {
      setError(err.message || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 p-4">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-500 to-blue-600 flex items-center justify-center text-white font-bold text-lg">
              D
            </div>
            <div>
              <div className="font-bold text-xl text-slate-800">Destpoint</div>
              <div className="text-xs text-slate-400">Plataforma de viajes</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">Usuario</label>
              <input
                type="text"
                value={usr}
                onChange={(e) => setUsr(e.target.value)}
                required
                autoFocus
                className="w-full px-3 py-2.5 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="tu usuario"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">Contraseña</label>
              <input
                type="password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                required
                className="w-full px-3 py-2.5 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-lg bg-gradient-to-r from-teal-500 to-blue-600 text-white font-semibold hover:opacity-90 disabled:opacity-50 transition"
            >
              {loading ? 'Entrando…' : 'Entrar'}
            </button>
          </form>
          <p className="text-center text-sm text-slate-500 mt-4">
            ¿Eres una agencia nueva?{' '}
            <a href="/registro" className="text-teal-600 font-semibold hover:underline">
              Regístrate aquí
            </a>
          </p>
        </div>
        <p className="text-center text-slate-400 text-xs mt-4">Conectado a Frappe (ERPNext)</p>
      </div>
    </div>
  );
}
